module.exports = __webpack_public_path__ + "img/blog-12.7b6965c2.jpg";